import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Headers, Http, Request, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Attachment } from './attachment.model';

@Injectable()
export class AttachmentService {

  constructor(
    private http: HttpClient) { }

  searchAttachments(searchString: string): Observable<Attachment[]> {
    // see https://github.com/surfer77/mongoose-string-query for full API!
    return this.http.get<Attachment[]>('/api/attachments/search?' + searchString).map((attachments: Attachment[]) => {
      return attachments;
    }).catch(this.handleError);

  }

  // Defines routes for attachment data retrieval
  getAttachments(): Observable<Attachment[]> {
    return this.http.get<Attachment[]>('/api/attachments').map((attachments: Attachment[]) => {
      return attachments;
    }).catch(this.handleError);
  }

  getAttachmentsFromIds(contactIds: string): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(`/api/attachments/listByIds/${contactIds}`);
    // ).get(requireAuth, contactCtrl.get);
  }

  // Defines routes for attachment data retrieval
  downloadAttachment(id: string): Observable<Blob> {
    return this.http.get(`/api/attachment/download/${id}`, { responseType: 'blob' });
  }

  countAttachments(): Observable<number> {
    return this.http.get<number>('/api/attachments/count');
  }

  addAttachment(attachment: Attachment): Observable<Attachment> {
    return this.http.post<Attachment>('/api/attachment', attachment);
  }

  getAttachmentFromId(id: string): Observable<Attachment> {
    return this.http.get<Attachment>(`/api/attachment/${id}`);
  }

  getAttachment(attachment: Attachment): Observable<Attachment> {
    return this.http.get<Attachment>(`/api/attachment/${attachment._id}`);
  }

  editAttachment(attachment: Attachment): Observable<string> {
    return this.http.put(`/api/attachment/${attachment._id}`, attachment, { responseType: 'text' });
  }

  deleteAttachment(attachment: Attachment): Observable<string> {
    return this.http.delete(`/api/attachment/${attachment._id}`, { responseType: 'text' });
  }


  private handleError(error: Response) {
    return Observable.throw(error.statusText);
  }

}



// WEBPACK FOOTER //
// ./client/app/shared/attachments/attachment.service.ts